


import React, { useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  Divider,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import document1 from "../../../../assets/document1.svg";
import CustomButton from "../../../../components/CustomButton";
import { useTranslation } from "react-i18next";
const GeneratedDocumentModal = ({ open, onClose, data }) => {
const {t} =useTranslation()

  if (!data) {
    return (
      <Modal open={open} onClose={onClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 350,
            bgcolor: "#fff",
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
            textAlign: "center",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          <Typography>{t("generatedDocumentModal.no_data")}</Typography>
        </Box>
      </Modal>
    );
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 450,
          bgcolor: "#fff",
          borderRadius: 3,
          boxShadow: 24,
          p: 3,
          fontFamily: "Poppins, sans-serif",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: 18,
              fontWeight: 600,
              color: "#003149",
              fontFamily: "Poppins, sans-serif",
            }}
          >
      {t("generatedDocumentModal.title")}

          </Typography>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider sx={{ mb: 2 }} />

        {/* Document Info */}
        <Box sx={{ textAlign: "center", mb: 2 }}>
          <img
            src={document1}
            alt="Document"
            width={50}
            style={{ marginBottom: "10px" }}
          />
          <Typography
            sx={{
              fontSize: 13,
              color: "#172B4D",
              fontWeight: 500,
              mb: 2,
              mt: 0.5,
              fontFamily: "Poppins, sans-serif",
              wordBreak: "break-word",
              whiteSpace: "normal",
              textAlign: "center",
              maxWidth: 300,
              mx: "auto",
            }}
          >
            {data?.filename || "Document Ready"}
          </Typography>

    {/* <CustomButton
  label={t("generatedDocumentModal.buttons.download_pdf")}
  size="small"
  onClick={() => {
    const link = document.createElement("a");
    link.href = data?.pdfUrl;
    link.download = data?.filename;
    link.click();
  }}
/> */}
<CustomButton
  label={t("generatedDocumentModal.buttons.download_pdf")}
  size="small"
  onClick={() => {
    try {
      // Use blob if available, otherwise use URL
      let downloadUrl = data?.pdfUrl;
      let blob = data?.blob;

      if (blob) {
        // Create a fresh URL from the blob to ensure it's valid
        downloadUrl = window.URL.createObjectURL(blob);
      }

      if (!downloadUrl) {
        console.error("❌ No PDF URL or blob available");
        alert("PDF download failed: No valid PDF data available.");
        return;
      }

      console.log("📥 Downloading PDF:", data?.filename);
      console.log("🔗 Download URL:", downloadUrl);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = data?.filename || "document.pdf";
      link.style.display = "none";
      
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      setTimeout(() => {
        document.body.removeChild(link);
        // Revoke URL after download starts
        if (downloadUrl && downloadUrl.startsWith("blob:")) {
          window.URL.revokeObjectURL(downloadUrl);
        }
      }, 100);

      // ⏳ Close modal after 2 seconds
      setTimeout(() => {
        onClose();
      }, 2000);
    } catch (error) {
      console.error("❌ Error downloading PDF:", error);
      alert("Failed to download PDF: " + error.message);
    }
  }}
/>

        </Box>
      </Box>
    </Modal>
  );
};

export default GeneratedDocumentModal;

